__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/67c8f4e6fee0b06d5e3d83d4e1242f5a56c46f3ec70626e08d13b1c9/";